import { enviroment } from '@utils/config';
import createTokenProvider from '@utils/auth/createTokenProvider';
import friendlyResponseError from '@utils/middlewares/friendlyResponseError';
import storageClientTarget from '@utils/storageClientTarget';

const { getToken } = createTokenProvider;

function apiHandler() {

  const { apiUrl } = enviroment;
  const publicUrl = `${apiUrl}/jwt/v1`;
  // eslint-disable-next-line no-unused-vars
  let tenantUrl = null;

  if (enviroment.isDev && storageClientTarget.get()) {

    const { domain } = storageClientTarget.get();
    tenantUrl = `${apiUrl}/${domain}/jwt/v1`;

  }

  async function getHeaders({ headers: tempHeaders, reqAuth }) {

    const headers = {
      'Content-Type': 'application/json',
      ...tempHeaders,
    };

    if (!headers['Content-Type']) delete headers['Content-Type'];

    if (!reqAuth) return headers;

    const token = await getToken();
    headers.Authorization = `bearer ${token}`;
    return headers;

  }

  async function commonRequest(endpoint, {
    method, formData, body, signal, headers, reqAuth,
  }) {

    const finalHeaders = await getHeaders({ headers, reqAuth });

    return new Promise((resolve, reject) => {

      let res = {};
      fetch(endpoint, {
        method,
        signal,
        headers: { ...finalHeaders, 'Access-Control-Allow-Origin': '*' },
        body: formData || JSON.stringify(body),
      })
        .then((response) => {

          res = response;
          return response.text();

        })
      // eslint-disable-next-line consistent-return
        .then((text) => {

          try {

            const data = JSON.parse(text);
            if (!res.ok) return reject(friendlyResponseError(res, data));
            resolve(data);

          } catch (error) {

            if (!res.ok) return reject(friendlyResponseError(res, null, error));
            resolve(friendlyResponseError(res, null, error));

          }

        })
        .catch((error) => {

          // eslint-disable-next-line no-console
          console.log('error ', error);
          reject(friendlyResponseError({ ...res, error }));

        });

    });

  }

  return {
    commonRequest,

    async tenantRequest(path, {
      method, formData, body, signal, headers, reqAuth,
    }) {

      const endpoint = `${publicUrl}${path}`;
      return commonRequest(endpoint, {
        method, formData, body, signal, headers, reqAuth,
      });

    },

    async publicRequest(path, {
      method, formData, body, signal, headers, reqAuth,
    }) {

      const endpoint = `${publicUrl}${path}`;
      return commonRequest(endpoint, {
        method, formData, body, signal, headers, reqAuth,
      });

    },

    async cleanRequest(path, {
      method, formData, body, signal, headers, reqAuth,
    }) {

      const endpoint = `${apiUrl}${path}`;
      return commonRequest(endpoint, {
        method, formData, body, signal, headers, reqAuth,
      });

    },

    setTenant({ domain } = {}) {

      tenantUrl = domain ? `${apiUrl}/jwt/v1` : null;

    },
  };

}

export default apiHandler();
